"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var bases_1 = require("../../bases");
var pageTypes_1 = require("../pageTypes");
var allMeetingsTable_1 = require("./allMeetingsTable");
var AllMeetingsPage = /** @class */ (function (_super) {
    __extends(AllMeetingsPage, _super);
    function AllMeetingsPage(api, navigator, currentUserManager) {
        var _this = _super.call(this, pageTypes_1.default.AllMeetingsList, 'All Meetings List') || this;
        _this.api = api;
        _this.navigator = navigator;
        _this.currentUserManager = currentUserManager;
        _this.table = new allMeetingsTable_1.default(_this.api, _this.currentUserManager, _this.navigator);
        return _this;
    }
    return AllMeetingsPage;
}(bases_1.BasePage));
exports.default = AllMeetingsPage;
